<template>
  <SvgIcon viewBox="0 0 32 32" fill="none" style="stroke-width: unset">
    <rect
      x="1.5"
      y="2.5"
      width="29"
      height="27"
      rx="1.5"
      fill="white"
      stroke="#BBB"
    ></rect
    ><rect
      x="16"
      y="5"
      width="12"
      height="22"
      rx="1"
      fill="var(--g-color-primary)"
      stroke="none"
    ></rect>
  </SvgIcon>
</template>

<script>
import { SvgIcon } from '@campsite-bio/component-lib';

export default {
  components: {
    SvgIcon,
  },
};
</script>

<style lang="scss" scoped></style>
